import React, { useState } from 'react';
import Tooltip from '@mui/material/Tooltip';
import { useTranslation } from 'react-i18next';
import { ReactComponent as CopyIcon } from '../../icons/copy.svg';
import './Iban.css';

const IBAN = 'ES21 0049 3159 7024 1416 7359';

const Iban = () => {
  const { t } = useTranslation();

  const [tooltipText, setTooltipText] = useState(t("iban.labels.0"));
  const [openTooltip, setOpenTooltip] = useState(false);

  const handleCopy = () => {
    navigator.clipboard.writeText(IBAN);
    setTooltipText(t("iban.labels.1"));
    setOpenTooltip(true);

    // Réinitialiser le texte et fermer le tooltip après 3,5 secondes
    setTimeout(() => {
      setTooltipText(t("iban.labels.0"));
      setOpenTooltip(false);
    }, 3500);
  };

  const handleTooltipOpen = () => {
    setOpenTooltip(true);
  };

  const handleTooltipClose = () => {
    setOpenTooltip(false);
  };

  return (
    <div className="iban-section">
      <div className="iban-container">
        <p className="iban-title">IBAN</p>
        <div className="iban-content">
          <Tooltip
            title={tooltipText}
            arrow
            open={openTooltip}
            onOpen={handleTooltipOpen}
            onClose={handleTooltipClose}
          >
            <button
              className="iban-copy-button"
              onClick={handleCopy}
              onMouseEnter={handleTooltipOpen}
              onMouseLeave={handleTooltipClose}
            >
              <CopyIcon className="copy-icon" />
            </button>
          </Tooltip>
          <p className="iban-text">{IBAN}</p>
        </div>
      </div>
    </div>
  );
};

export default Iban;